import { IEquipmentAttributeTypes } from 'types/graphqlTypes'
import * as yup from 'yup'
import { REQUIRED_MESSAGE } from '../../constants'

export const SpecializedEquipmentSchemaObject = {
  /**
   * @example 'This is a description of the specialized equipment'
   */
  [IEquipmentAttributeTypes.specialized_description_details]: yup
    .string()
    .required(REQUIRED_MESSAGE),
}

export const SpecializedEquipmentSchema = yup.object(SpecializedEquipmentSchemaObject)

export type TSpecializedEquipmentSchema = yup.InferType<typeof SpecializedEquipmentSchema>
